import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Chauffeurdrivenpremium() {



  const cardData =
  {
    keyword: 'Chauffeur Driven Premium Cabs in Bangalore',
    heading: 'Aaryan Travels: Chauffeur Driven Premium Cabs in Bangalore',
    headingDescription: 'Aaryan Travels offers Chauffeur Driven Premium Cabs in Bangalore for executives, VIP guests, and travelers who value comfort, professionalism, and luxury on the move. Whether it’s airport pickups from Kempegowda International Airport, corporate meetings in Whitefield or Electronic City, or leisure trips to Mysore and Coorg, our fleet of luxury sedans and high-end SUVs ensures an elegant and stress-free journey. With uniformed and well-trained chauffeurs, GPS-enabled vehicles, and 24/7 service availability, we provide a premium travel experience tailored to both business and leisure needs. Aaryan Travels is the preferred choice for chauffeur-driven premium cab services in Bangalore.',

    top: 'Top Places to Visit in Bangalore with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre green paradise known for its rare plant species, serene lake, and the iconic Glass House inspired by London’s Crystal Palace. The annual flower show attracts thousands of visitors. Joggers, photographers, and nature lovers frequent its peaceful pathways. Lalbagh is Bangalore’s blooming oasis of tranquility."
  },
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in 1878, resembles England’s Windsor Castle with its Tudor-style architecture, wooden interiors, and sprawling gardens. Visitors can explore royal artifacts, paintings, and grand halls. Cultural events and concerts are often hosted on the palace grounds. Bangalore Palace is the city’s majestic symbol of royal heritage."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a lush 300-acre urban park offering wide green lawns, walking trails, and colonial-era statues. Known as the 'lungs of Bangalore', it provides a refreshing escape for joggers, families, and pet lovers. The surrounding library and Vidhana Soudha enhance its scenic charm. Cubbon Park is Bangalore’s evergreen retreat in the city center."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "ISKCON Temple is a grand spiritual complex dedicated to Lord Krishna, featuring gold-plated kalashas and intricate carvings. Daily rituals, kirtans, and prasadam distribution uplift devotees. The in-house Govinda’s restaurant serves delicious sattvic meals. ISKCON Temple is Bangalore’s serene sanctuary of devotion and peace."
  },
  {
    "title": "Nandi Hills",
    "description": "Located about 60 km from the city, Nandi Hills is a popular sunrise viewpoint offering misty landscapes and cool breezes. The 18th-century Tipu Sultan’s Summer Palace adds historical charm. Adventure seekers enjoy cycling and trekking. Clouds often float beneath the hilltop, creating a heavenly experience. Nandi Hills is Bangalore’s scenic escape at dawn."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s most bustling shopping hub filled with fashion stores, footwear stalls, and jewelry shops. Bargain hunters explore every lane for trendy deals. Street food vendors and vibrant crowds make it lively throughout the day. Commercial Street is Bangalore’s go-to destination for shopping and street vibes."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is Karnataka’s grand legislative building, designed in Neo-Dravidian architecture. Its majestic domes, pillars, and granite facade make it a stunning landmark. Though entry inside is restricted, tourists admire it from outside, especially when illuminated at night. Vidhana Soudha is Bangalore’s architectural pride of governance."
  },
  {
    "title": "UB City",
    "description": "UB City is a luxury commercial complex featuring premium brands, fine-dining restaurants, and rooftop lounges. The European-style architecture and open-air amphitheater host live events regularly. It’s a popular hangout spot for professionals and partygoers. UB City is Bangalore’s hub of luxury and lifestyle."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park is a wildlife reserve offering safari rides to spot tigers, lions, and bears in natural habitats. It also includes a butterfly park and a mini zoo. Nature lovers enjoy trekking and photography in the surrounding forests. Bannerghatta is Bangalore’s adventurous encounter with wildlife."
  },
  {
    "title": "MG Road & Brigade Road",
    "description": "MG Road and Brigade Road form the city’s iconic commercial stretch lined with cafes, pubs, bookstores, and fashion outlets. Known for nightlife and cosmopolitan vibes, it’s a favorite hangout for youngsters. During festivals, the streets are lit up beautifully. MG Road is Bangalore’s pulse of urban energy."
  }
],


"services": [
  {
    "name": "Chauffeur Driven Premium Cabs in Bangalore",
    "description": "Chauffeur Driven Premium Cabs in Bangalore provide luxury transportation with professional drivers, ensuring a comfortable and elegant travel experience for business and personal needs."
  },
  {
    "name": "Bangalore Chauffeur Premium Cab",
    "description": "Bangalore Chauffeur Premium Cab offers high-end vehicles with skilled chauffeurs who prioritize safety, punctuality, and customer satisfaction for all premium rides."
  },
  {
    "name": "Executive Chauffeur Cab Bangalore",
    "description": "Executive Chauffeur Cab Bangalore caters to corporate clients with chauffeur-driven executive cars, combining professionalism and comfort for important business trips."
  },
  {
    "name": "Luxury Chauffeur Service Bangalore",
    "description": "Luxury Chauffeur Service Bangalore specializes in providing chauffeur-driven luxury vehicles equipped with modern amenities for a sophisticated travel experience."
  },
  {
    "name": "Premium Vehicle with Driver Bangalore",
    "description": "Premium Vehicle with Driver Bangalore offers a wide selection of luxury cars paired with professional drivers, ideal for corporate travel, special occasions, and VIP transport."
  },
  {
    "name": "Corporate Premium Chauffeur Bangalore",
    "description": "Corporate Premium Chauffeur Bangalore delivers tailored chauffeur services for corporate clients, emphasizing discretion, professionalism, and timely service."
  },
  {
    "name": "Best Chauffeur Premium Cab Bangalore",
    "description": "Best Chauffeur Premium Cab Bangalore is renowned for excellent customer service, a well-maintained fleet, and highly trained chauffeurs ensuring premium travel experiences."
  },
  {
    "name": "Affordable Chauffeur Premium Cab Bangalore",
    "description": "Affordable Chauffeur Premium Cab Bangalore provides luxury chauffeur services at competitive prices, making premium travel accessible without compromising quality."
  },
  {
    "name": "Sedan Chauffeur Premium Bangalore",
    "description": "Sedan Chauffeur Premium Bangalore offers sleek sedan cars driven by professional chauffeurs, perfect for business and personal premium travel needs."
  },
  {
    "name": "SUV Chauffeur Premium Bangalore",
    "description": "SUV Chauffeur Premium Bangalore provides spacious and luxurious SUVs with expert chauffeurs, ideal for group travel or clients with extra luggage."
  },
  {
    "name": "Monthly Chauffeur Premium Cab Bangalore",
    "description": "Monthly Chauffeur Premium Cab Bangalore offers subscription-based premium chauffeur services, providing consistent luxury transportation for businesses and individuals."
  },
  {
    "name": "Prestige Chauffeur Cab Bangalore",
    "description": "Prestige Chauffeur Cab Bangalore specializes in exclusive chauffeur-driven services featuring high-end prestige vehicles and exceptional customer care."
  },
  {
    "name": "Chauffeur Premium Booking Bangalore",
    "description": "Chauffeur Premium Booking Bangalore allows easy online reservations for premium chauffeur-driven cabs, offering instant confirmations and convenient scheduling."
  },
  {
    "name": "Online Chauffeur Premium Cab Bangalore",
    "description": "Online Chauffeur Premium Cab Bangalore provides a digital platform for seamless booking, tracking, and managing of chauffeur-driven premium cab services."
  },
  {
    "name": "Premium Driver Cab Bangalore",
    "description": "Premium Driver Cab Bangalore offers professional drivers with luxury vehicles to ensure safe, comfortable, and stylish transportation tailored to client needs."
  }
],
"tableData": [
  ["Chauffeur Driven Premium Cabs in Bangalore", "Bangalore Chauffeur Premium Cab"],
  ["Executive Chauffeur Cab Bangalore", "Luxury Chauffeur Service Bangalore"],
  ["Premium Vehicle with Driver Bangalore", "Corporate Premium Chauffeur Bangalore"],
  ["Best Chauffeur Premium Cab Bangalore", "Affordable Chauffeur Premium Cab Bangalore"],
  ["Sedan Chauffeur Premium Bangalore", "SUV Chauffeur Premium Bangalore"],
  ["Monthly Chauffeur Premium Cab Bangalore", "Prestige Chauffeur Cab Bangalore"],
  ["Chauffeur Premium Booking Bangalore", "Online Chauffeur Premium Cab Bangalore"],
  ["Premium Driver Cab Bangalore", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Chauffeur Driven Premium Cabs in Bangalore",
    "WhyChoosedescription": "Aaryan Travels provides top-tier chauffeur driven premium cabs in Bangalore for a refined and stress-free travel experience."
  },
  {
    "WhyChooseheading": "Professional and Courteous Chauffeurs",
    "WhyChoosedescription": "Our trained drivers deliver punctual and respectful service, ensuring a smooth ride every time."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Luxurious Vehicles",
    "WhyChoosedescription": "Travel in style with our well-maintained, air-conditioned premium vehicles, sanitized for your safety."
  },
  {
    "WhyChooseheading": "Expert Drivers with Local Route Knowledge",
    "WhyChoosedescription": "Our chauffeurs are well-versed in Bangalore’s roads and traffic patterns for efficient travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy clear, upfront pricing that includes all charges—no surprises at the end of your journey."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support Assistance",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings and customer queries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Whether it’s an hourly, daily, or full-day trip, our chauffeur driven cabs are available as per your needs."
  },
  {
    "WhyChooseheading": "Variety of Premium Cab Options",
    "WhyChoosedescription": "Choose from a range of premium sedans, SUVs, and luxury vehicles suited for any occasion or requirement."
  }
]








































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer chauffeur driven premium cabs in Bangalore?',
    answer: 'Yes, Aaryan Travels offers luxurious chauffeur driven premium cabs in Bangalore for both personal and business travel.',
  },
  {
    question: 'How can I book chauffeur driven premium cabs in Bangalore with Aaryan Travels?',
    answer: 'You can book easily via our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of premium vehicles are available with chauffeur services in Bangalore?',
    answer: 'Aaryan Travels provides a fleet of premium sedans, SUVs, and executive-class cars with professional chauffeurs.',
  },
  {
    question: 'Are the chauffeurs professionally trained for premium cab services in Bangalore?',
    answer: 'Absolutely. Our chauffeurs are well-trained, courteous, and experienced to provide a smooth and elite travel experience.',
  },
  {
    question: 'Can I hire chauffeur driven premium cabs for hourly or full-day usage in Bangalore?',
    answer: 'Yes, Aaryan Travels offers flexible booking options including hourly, half-day, and full-day rentals with chauffeur services.',
  },
  {
    question: 'Is chauffeur driven premium cab service available 24x7 in Bangalore?',
    answer: 'Yes, our chauffeur driven cab services are available round-the-clock to match your travel needs.',
  },
  {
    question: 'Are safety and hygiene standards maintained in chauffeur driven premium cabs?',
    answer: 'Yes, all vehicles are thoroughly sanitized, and chauffeurs follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment options are accepted for chauffeur driven premium cabs in Bangalore?',
    answer: 'We accept cash, digital wallets, UPI, and all major card payments for a hassle-free experience.',
  },
  {
    question: 'Is customer support available during the chauffeur driven cab ride?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your ride.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Rao',
    feedback: 'Booked a chauffeur driven premium cab in Bangalore from Aaryan Travels — extremely professional and timely service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Divya Shetty',
    feedback: 'The chauffeur was polite, the car was spotless, and the entire experience felt truly premium. Thank you Aaryan Travels!',
    rating: 5,
  },
];























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const chauffeurDrivenPremiumCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Chauffeur Driven Premium Cabs in Bangalore",
  "description": "Aaryan Travels provides chauffeur driven premium cabs in Bangalore, including luxury sedans and SUVs for executive, corporate, and personal use with professional drivers.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Bangalore"
  },
  "serviceType": "Chauffeur Driven Premium Cab Service",
  "keywords": "Chauffeur Driven Premium Cabs in Bangalore, Bangalore Chauffeur Premium Cab, Executive Chauffeur Cab Bangalore, Luxury Chauffeur Service Bangalore, Premium Vehicle with Driver Bangalore, Corporate Premium Chauffeur Bangalore, Best Chauffeur Premium Cab Bangalore, Affordable Chauffeur Premium Cab Bangalore, Sedan Chauffeur Premium Bangalore, SUV Chauffeur Premium Bangalore, Monthly Chauffeur Premium Cab Bangalore, Prestige Chauffeur Cab Bangalore, Chauffeur Premium Booking Bangalore, Online Chauffeur Premium Cab Bangalore, Premium Driver Cab Bangalore"
};





  return (
    <div>

<Helmet>
  <title>Chauffeur Driven Premium Cabs in Bangalore | Luxury Chauffeur Services | Aaryan Travels</title>
  <meta
    name="description"
    content="Book chauffeur driven premium cabs in Bangalore with Aaryan Travels. Luxury sedans and SUVs with professional drivers for executive and corporate travel."
  />
  <meta
    name="keywords"
    content="Chauffeur Driven Premium Cabs in Bangalore, Bangalore Chauffeur Premium Cab, Executive Chauffeur Cab Bangalore, Luxury Chauffeur Service Bangalore, Premium Vehicle with Driver Bangalore, Corporate Premium Chauffeur Bangalore, Best Chauffeur Premium Cab Bangalore, Affordable Chauffeur Premium Cab Bangalore, Sedan Chauffeur Premium Bangalore, SUV Chauffeur Premium Bangalore, Monthly Chauffeur Premium Cab Bangalore, Prestige Chauffeur Cab Bangalore, Chauffeur Premium Booking Bangalore, Online Chauffeur Premium Cab Bangalore, Premium Driver Cab Bangalore"
  />
  <script type="application/ld+json">
    {JSON.stringify(chauffeurDrivenPremiumCabsSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/60.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Chauffeurdrivenpremium;